import React, { useEffect, useState } from "react";
import PageBar from "../../components/dashboard/page-bar/PageBar";
import Jobs from "../../components/jobs/Jobs";
import axios from "axios";
import { deleteJobsList, getJobsList } from "../../components/apifile/ApiFiles";
import { baseUrl } from "../../components/login/baseUrl";
import { Loaders } from "../Loaders";

const JobsPage = () => {
  const [loader, setLoader] = useState(false)
  const [data, setData] = useState();
  const [total, setTotalCount] = useState()

  const getJobs = async (page) => {

    setLoader(true)
    try {
      const res = await getJobsList(10, page)
      // console.log(res?.data);
      setData(res?.data);
      setTotalCount(res?.data?.totalJobs)
      setLoader(false)
    } catch (error) {
      setLoader(false)
      alert("Error");
    }
  };
  const getJobs2 = async (page) => {
    try {
      const res = await axios.get(
        `${baseUrl}jobs/allJobs?page=${page}&count=10`
      );
      // console.log(res?.totalJobs);

      setData(res?.data);

    } catch (error) {
      alert("Error");
    }
  };

  useEffect(() => {
    getJobs(1);
  }, []);

  const handleDelete = async (id) => {
    try {
      const res = await deleteJobsList(id)
      getJobs(1)
    } catch (error) {
      alert("Error");
    }
  };

  const onChangeVal = (e) => {
    // console.log(e);
    getJobs(e)

  };
  return (
    <>
      {loader && <Loaders />}
      <div className="pageWrapper">
        <PageBar title="Jobs" />
        <h3 className="page-title">
          Manage Jobs <small>Jobs</small>
        </h3>
        <Jobs data={data} handleDelete={handleDelete} getJobs={getJobs2} total={total} onChangeVal={onChangeVal} />
      </div>
    </>
  );
};

export default JobsPage;
